const SESSION_STORAGE_KEY = {
	CHECKOUT_INTENT: 'checkout_intent',
	GO_TO: 'go_to',
	SHOW_NO_INFO_MODAL: 'show_no_info_modal',
	ACTIVE_TAB: 'active_tab',
	VIEWED_FROM_APP: 'viewed_from_app',
	VALID_REFERRAL_CODE: 'valid_referral_code',
};

export default SESSION_STORAGE_KEY;
